import React from 'react'

export const ClientesPage = () => {
  return (
    <div>ClientesPage</div>
  )
}
